module.exports = __webpack_public_path__ + "static/img/banner.7efd666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/banner.png
// module id = zSr9
// module chunks = 0